/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Body2Inputs */

const es_home_intro_body2 = /** @type {(inputs: Home_Intro_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En lugar de saltar entre Google Drive, Gmail, Dropbox, calendarios y otros sistemas, Nexata unifica todos estos servicios en un único buscador inteligente que entiende el contexto y devuelve respuestas precisas, no solo resultados.`)
};

const en_home_intro_body2 = /** @type {(inputs: Home_Intro_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instead of jumping between Google Drive, Gmail, Dropbox, calendars, and other systems, Nexata unifies all these services into a single intelligent search engine that understands context and delivers precise answers — not just results.`)
};

/**
* | output |
* | --- |
* | "Instead of jumping between Google Drive, Gmail, Dropbox, calendars, and other systems, Nexata unifies all these services into a single intelligent search eng..." |
*
* @param {Home_Intro_Body2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_body2 = /** @type {((inputs?: Home_Intro_Body2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Body2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_body2(inputs)
	return en_home_intro_body2(inputs)
});
export { home_intro_body2 as "home.intro.body2" }